import { isCollegeSavings } from 'services/Products';
import { isEmpty } from 'lodash';

const COLLEGE_SAVINGS_CODE = '529';
const COLLEGE_SAVINGS_CONSTANT = 'collegeSavings';

const mapping = {
  all: () => true,
  retirement: ({ retirementAccount }) => retirementAccount,
  nonRetirement: ({ retirementAccount }) => !retirementAccount,
  owned: ({ owner }) => owner,
  related: ({ isRelated }) => isRelated,
  viewOnly: ({ isViewOnly }) => isViewOnly,
  smallBusiness: () => true
};

export const filterFunctionMapping = (
  filterType,
  providedProductTypes,
  accountIds = []
) => {
  const isCollegeSavingsFilterType =
    filterType === COLLEGE_SAVINGS_CODE ||
    filterType === COLLEGE_SAVINGS_CONSTANT;
  const isDefinedFilterType = filterType in providedProductTypes;
  if (isCollegeSavingsFilterType || isDefinedFilterType) {
    return isCollegeSavingsFilterType
      ? ({ productType }) => isCollegeSavings(productType)
      : ({ productType }) => productType === providedProductTypes[filterType];
  }

  if (mapping[filterType] && typeof mapping[filterType] === 'function') {
    return mapping[filterType];
  }

  return Array.isArray(accountIds) && !isEmpty(accountIds)
    ? ({ accountId }) => accountIds.includes(accountId)
    : ({ accountId }) => accountId === filterType;
};
